/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const channelDeliveryOutcomeDataChannelSchema = z.enum(['email', 'whatsapp'])

export type ChannelDeliveryOutcomeDataChannelSchema = z.infer<typeof channelDeliveryOutcomeDataChannelSchema>
